export default __webpack_public_path__ + "static/media/pixellab--web-design--04a--1200x900.6e35ee12.jpg";